<template>
  <div class="focus-areas">
    <h2 class="fs40 pb-20 pb-md-40">Focus areas</h2>

    <b-row>
      <b-col
        v-for="(industry, i) in visibleIndustries"
        :key="i"
        cols="6"
        md="3"
        class="pb-24"
      >
        <div class="area">
          <div class="icon">
            <img
              :src="
                require(`~/assets/img/icons/industries/${industry.value}.svg`)
              "
              :alt="industry.label"
            />
          </div>

          <div class="label">{{ industry.label }}</div>
        </div>
      </b-col>
    </b-row>

    <a v-if="shouldShowMoreButton" class="more" @click="isShowingAll = true"
      >See all {{ list.length }} focus areas <i class="icon icon-caret"></i
    ></a>
  </div>
</template>

<script>
export default {
  name: 'InvestorsFocusAreas',
  props: {
    investor: {
      type: Object,
      required: true
    },
    max: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    isShowingAll: false
  }),
  computed: {
    list() {
      const list = this.$store.getters['meta/industries']

      return (this.investor.industries || []).filter((industry) => {
        return list.find((item) => item.value === industry)
      })
    },
    shouldShowMoreButton() {
      return this.max < this.list.length && !this.isShowingAll
    },
    industries() {
      return this.$store.getters['meta/industries'].filter((item) => {
        return this.list.indexOf(item.value) > -1
      })
    },
    visibleIndustries() {
      return this.isShowingAll
        ? this.industries
        : this.industries.slice(0, this.max)
    }
  }
}
</script>

<style lang="scss" scoped>
.focus-areas {
  .area {
    height: rem(148px);
    border: 1px solid #d5d6d9;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .icon {
      padding-top: rem(14px);
      padding-bottom: rem(14px);

      img {
        max-height: 48px;
      }
    }

    .label {
      height: 48px;
      text-align: center;
      display: flex;
      align-items: center;
      padding: 0 rem(15px);
    }
  }

  .more {
    margin-top: 2rem;
    display: inline-block;
    font-weight: 700;
    color: $blue-900 !important;
    cursor: pointer;

    & > i {
      font-size: 0.7rem;
      margin-left: 0.3rem;
    }
  }
}
</style>
